exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn svg[data-v-013bc478],.list-group-item svg[data-v-013bc478]{margin-right:.5em}.mr-1rem[data-v-013bc478]{margin-right:1rem}", ""]);

// exports
